<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import Link from "./Link.svelte";
	import translations from "./HomepageSolutions.translations.json";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import SolutionsSection from "./SolutionsSection.svelte";
	import { solutionsPathMap } from "../../../core/schema/paths/solutionsPathMap.js";
	import { getTenant } from "../getTenant.js";

	const translate = getTranslate(translations);
	const tenant = getTenant();
</script>

<div class="border-lttertiary border-y">
	<div class="flex items-center gap-4 py-16 pl-4 md:justify-center md:pl-0">
		<span class="bg-ltprimary-200 h-px w-8"></span>
		<span class="text-ltprimary-200 uppercase">{translate("tag")}</span>
	</div>
	<div class="mx-4 mb-16 text-center md:mx-0">
		<h2 class="text-ltprimary mx-auto mb-4 max-w-[60rem] font-light uppercase tracking-wider">
			{translate("headline")}
		</h2>
		<div class="text-2md mx-auto mb-2 md:max-w-[37rem] lg:max-w-[46.813rem]">
			{translate("subheadline")}
		</div>
	</div>

	<SolutionsSection />

	<Link asButton variant="secondary" class="mx-auto my-16" icon={arrowRight} href="/{solutionsPathMap[tenant.locale]}">
		{translate("exploreOurSolutions")}
	</Link>
</div>
